// import logo from './logo.svg';
import "./App.css";
import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import ApplicationHome from "./components/ApplicationHome";

import Home from "./components/Home";
import Nav from "./components/Nav";
import ApplicationForm from "./components/ApplicationForm";
import LoginForm from "./components/LoginForm";
import forgotpass from "./components/forgotpass";
import sendOTP from "./components/sendOTP";
import newPassword from "./components/newPassword";

import FormSuccess from "./components/FormSuccess";
import AdminPage from "./components/AdminPage";
import AdminSideNav from "./components/AdminSideNav";
import MemberSideNav from "./components/MemberSideNav";
import AdminApplications from "./components/AdminApplications";
import NoticePage from "./components/Noticespage";
import NoticeForm from "./components/NoticeForm";

import AdminSeniorApplicatin from "./components/AdminSeniorApplication";
import AdminMembers from "./components/AdminMembers";
import AdminTransactions from "./components/AdminTransactions";
import AdminApplicationsView from "./components/AdminApplicationsView";
import AdminMembersView from "./components/AdminMembersView";
import AdminStudentView from "./components/AdminStudentView";
import AdminSetEmailPass from "./components/AdminSetEmailPass";
import AdminReset from "./components/AdminReset";
import AdminAddMem from "./components/AdminAddMem";
import ApplicationMemberLoginHome from "./components/ApplicationMemberLoginHome";
import MemberReset from "./components/MemberReset";
import MemberPage from "./components/MemberPage";
import MemberApplicationsView from "./components/MemberApplicationView";
import AdminOldMem from "./components/AdminOldMem";
import StudentMembers from "./components/StudentMembers";
import ApplicationHome from "./components/ApplicationHome";
import CoupleMembersView from "./components/couplesComponent/CoupleMembersView";
import CoupleList from "./components/couplesComponent/CoupleList";

import StudentPayment from "./components/StudentPayment";
import LifeMemberpage from "./components/LifeMemberpage";
import NoticesView from "./components/NoticesView";
import NoticeMemberView from "./components/NoticeMemberView";
import NoticeMemberPage from "./components/NoticeMemberPage";
import MemberKit from "./components/MemberKit";
import MemberForgetPass from "./components/MemberForgetPass";
import MemberSendOTP from "./components/MembersendOtp";
import MemberNewPass from "./components/MembernewPass";
import resMemsidenav from "./components/resMemsidenav";
import MembershipFormVedio from "./components/MembershipFormVedio";

import BulkEmail from "./components/BulkEmail";
import OTPForm from "./components/OTPForm";
import OTPLogin from "./components/OTPLogin";

// import NoticeMemberPage from "./components/NoticeMemberPage";

function App() {
  return (
    // <div className="App">
    // <ApplicationHome/>
    // </div>
    <>
      <Helmet>
        <title>NMO India</title>
      </Helmet>
      <Router>
        <div>
          <Nav />
          <Switch>
            <Route
              path="/resMemsidenav"
              exact
              component={resMemsidenav}
            ></Route>
            <Route
              path="/MembershipFormVedio"
              exact
              component={MembershipFormVedio}
            ></Route>
            <Route
              path="/LifeMemberpage"
              exact
              component={LifeMemberpage}
            ></Route>
            <Route
              path="/StudentPayment"
              exact
              component={StudentPayment}
            ></Route>
            <Route
              path="/ApplicationHome"
              exact
              component={ApplicationHome}
            ></Route>
            <Route
              path="/StudentMembers"
              exact
              component={StudentMembers}
            ></Route>
            <Route
              path="/admin/old_mem/:id"
              exact
              component={AdminOldMem}
            ></Route>
            <Route path="/" exact component={Home}></Route>
            <Route path="/bulkemail" exact component={BulkEmail}></Route>
            <Route path="/membership" exact component={ApplicationHome}></Route>
            <Route
              path="/membership/signup"
              exact
              component={ApplicationForm}
            ></Route>
            <Route
              path="/membership_login"
              exact
              component={ApplicationMemberLoginHome}
            ></Route>
            <Route
              path="/MemberForgetPass"
              exact
              component={MemberForgetPass}
            ></Route>
            <Route
              path="/MembersendOtp"
              exact
              component={MemberSendOTP}
            ></Route>
            <Route
              path="/MembernewPass"
              exact
              component={MemberNewPass}
            ></Route>
            <Route path="/login" exact component={LoginForm}></Route>
            <Route path="/OTPForm" exact component={OTPForm}></Route>
            <Route path="/OTPLogin" exact component={OTPLogin}></Route>

            <Route path="/Forgot_password" exact component={forgotpass}></Route>
            <Route path="/send_OTP" exact component={sendOTP}></Route>
            <Route path="/new_pass" exact component={newPassword}></Route>
            <Route
              path="/membership/signup/success"
              exact
              component={FormSuccess}
            ></Route>
            <Route
              path="/member/member_resetPass"
              exact
              component={MemberReset}
            ></Route>
            <Route path="/admin">
              <div
                style={{ width: "100vw", height: "100vh", overflowX: "hidden" }}
              >
                <AdminSideNav />
                <div className="contentFrame">
                  <Route
                    path="/admin/dashboard"
                    exact
                    component={AdminPage}
                  ></Route>
                  <Route
                    path="/admin/NoticePage"
                    exact
                    component={NoticePage}
                  ></Route>
                  <Route
                    path="/admin/NoticesView/:id"
                    exact
                    component={NoticesView}
                  ></Route>
                  <Route
                    path="/admin/NoticeForm"
                    exact
                    component={NoticeForm}
                  ></Route>
                  <Route
                    path="/NoticePage"
                    exact
                    component={NoticePage}
                  ></Route>
                  <Route
                    path="/admin/applications"
                    exact
                    component={AdminApplications}
                  ></Route>
                  <Route
                    path="/admin/senior_applications"
                    exact
                    component={AdminSeniorApplicatin}
                  ></Route>
                  <Route
                    path="/admin/applications/:id"
                    exact
                    component={AdminApplicationsView}
                  ></Route>
                  <Route
                    path="/admin/members"
                    exact
                    component={AdminMembers}
                  ></Route>
                  <Route
                    path="/admin/members/:id"
                    exact
                    component={AdminMembersView}
                  ></Route>
                  <Route
                    path="/admin/couple/members"
                    exact
                    component={CoupleList}
                  ></Route>
                  <Route
                    path="/admin/couple/members/:id"
                    exact
                    component={CoupleMembersView}
                  ></Route>

                  <Route
                    path="/admin/OldMem/:id"
                    exact
                    component={AdminOldMem}
                  ></Route>
                  <Route
                    path="/admin/student/:id"
                    exact
                    component={AdminStudentView}
                  ></Route>
                  <Route
                    path="/admin/reset_password"
                    exact
                    component={AdminReset}
                  ></Route>
                  <Route
                    path="/admin/set_email_pass"
                    exact
                    component={AdminSetEmailPass}
                  ></Route>

                  {/* // 21 oct jyoti , added "/admin/set_eamil_pass"  API */}
                  <Route
                    path="/admin/add_member"
                    exact
                    component={AdminAddMem}
                  ></Route>
                  <Route
                    path="/admin/transactions"
                    exact
                    component={AdminTransactions}
                  ></Route>
                  <Route
                    path="/admin/MemberKit"
                    exact
                    component={MemberKit}
                  ></Route>
                </div>
              </div>
            </Route>

            <Route path="/member">
              <div
                style={{ width: "100vw", height: "100vh", overflowX: "hidden" }}
              >
                <MemberSideNav />
                <div className="contentFrame">
                  <Route
                    path="/member/NoticeMemberPage"
                    exact
                    component={NoticeMemberPage}
                  ></Route>
                  <Route
                    path="/member/NoticeMember/:id"
                    exact
                    component={NoticeMemberView}
                  ></Route>
                  <Route
                    path="/member/deshboard"
                    exact
                    component={MemberPage}
                  ></Route>

                  <Route
                    path="/member/mydetials/:id"
                    exact
                    component={MemberApplicationsView}
                  ></Route>
                  <Route
                    path="/member/MemberKit"
                    exact
                    component={MemberKit}
                  ></Route>
                  {/* <Route path="/admin/applications" exact component={AdminApplications}></Route>
              <Route path="/admin/senior_applications" exact component={AdminSeniorApplicatin}></Route> */}
                </div>
              </div>
            </Route>
          </Switch>
        </div>
      </Router>
    </>
  );
}

export default App;
